import React, { useEffect, useRef } from "react";

export default function Textarea({
  onChange,
  placeholder = "",
  value = "",
  className,
  classNameInside = "",
  classNameParent,
  maxLength = 1000,
  name,
  id,
  validation,
  error,
  autocomplete = "off",
  disabled = false,
  onKeyDown,
  readOnly,
  style = "",
}) {
  const textareaRef = useRef(null);

  // const adjustHeight = () => {
  // 	const textarea = textareaRef.current;
  // 	if (textarea) {
  // 		// Reset height to ensure proper calculation
  // 		textarea.style.height = "auto";
  // 		// Set new height based on scrollHeight
  // 		textarea.style.height = `${textarea.scrollHeight}px`;
  // 	}
  // };

  // useEffect(() => {
  // 	adjustHeight();
  // }, [value]); // Re-adjust when value changes

  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
    // adjustHeight();
  };

  return (
    <div className={`flex gap-2 w-full ${classNameParent}`}>
      <div className={`${className ? className : "w-full"}`}>
        <textarea
          id={id}
          ref={textareaRef}
          name={name}
          onChange={handleChange}
          value={value}
          readOnly={readOnly}
          onKeyDown={onKeyDown}
          maxLength={maxLength}
          className={`w-full border-2 focus:outline-yellow-400 rounded-md p-1 overflow-hidden ${classNameInside}`}
          placeholder={placeholder}
          {...validation}
          autocomplete={autocomplete}
          autocompleteOff
          list="autocompleteOff"
          style={{
            height: "150px",
            overflowY: "auto",
          }}
          aria-autocomplete="none"
          disabled={disabled}
          rows={1} // Start with one row
        />
        <p className="text-end">
          {value !== "" ? value.length : 0}/{maxLength}
        </p>
      </div>
      {error}
    </div>
  );
}
